import { useEffect, useState } from 'react';
import Icon from '../../../components/AppIcon';
import { HeroSection as HeroSectionType } from '../types';

interface HeroSectionProps {
  data: HeroSectionType;
  onPrimaryCTA: () => void;
  onSecondaryCTA: () => void;
  className?: string;
}

const HeroSection = ({ data, onPrimaryCTA, onSecondaryCTA, className = '' }: HeroSectionProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section
      id="home"
      className={`relative min-h-screen flex items-center justify-center px-6 py-20 ${className}`}
    >
      <div
        className={`max-w-5xl mx-auto text-center space-y-8 transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        <h1
  className={`
    relative
    text-3xl sm:text-4xl lg:text-5xl xl:text-5xl 
    font-extrabold 
    leading-snug tracking-tight 
    max-w-4xl mx-auto text-balance
    text-gradient animate-fadeup
  `}
>
  <span className="hero-shimmer">{data.headline}</span>

  {/* soft glow layer */}
  <span className="absolute inset-0 blur-2xl opacity-20 bg-gradient-to-r from-green-400/40 to-emerald-500/40 -z-10"></span>
</h1>

        <p
  className="
    text-base 
    sm:text-lg 
    lg:text-xl 
    text-muted-foreground 
    max-w-3xl 
    mx-auto 
    leading-relaxed 
    text-balance
  "
>
  {data.subheadline}
</p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-8">
          <button
            onClick={onPrimaryCTA}
            className="flex items-center space-x-2 px-8 py-4 rounded-lg bg-primary text-primary-foreground font-semibold text-lg hover:bg-primary/90 transition-all duration-250 shadow-glass"
          >
            <span>{data.primaryCTA}</span>
            <Icon name="ArrowRight" size={20} />
          </button>

          <button
            onClick={onSecondaryCTA}
            className="flex items-center space-x-2 px-8 py-4 rounded-lg glass-effect text-foreground font-semibold text-lg hover:bg-muted/50 transition-all duration-250"
          >
            <span>{data.secondaryCTA}</span>
            <Icon name="ChevronDown" size={20} />
          </button>
        </div>

        <div className="flex items-center justify-center space-x-6 pt-12 text-muted-foreground">
          <div className="flex items-center space-x-2">
            <Icon name="Shield" size={20} className="text-success" />
            <span className="text-sm">NDA Protected</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="CheckCircle2" size={20} className="text-success" />
            <span className="text-sm">Field Tested</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Zap" size={20} className="text-success" />
            <span className="text-sm">Mission Critical</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
